import { render } from "./charts.vue?vue&type=template&id=4d4c7d2b&ts=true"
import script from "./charts.vue?vue&type=script&lang=ts"
export * from "./charts.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__